import { HTMLAttributes } from 'react';
import { Highlight } from 'shared/components';

import { SearchLocationAutocompleteOption } from '../../types';

interface SearchLocationAutocompleteOptionProps {
    option: SearchLocationAutocompleteOption;
    elementProps: HTMLAttributes<HTMLLIElement>;
}

export default function SearchLocationAutocompleteOptionRow({ option, elementProps }: SearchLocationAutocompleteOptionProps) {
    return (
        <li { ...elementProps }>
            <Highlight text={ option?.structuredFormatting?.mainText || '' }
                highlights={ option?.structuredFormatting?.mainTextMatchedSubstrings }
                sx={{
                    em: {
                        color: 'inherit',
                        backgroundColor: 'inherit',
                        fontWeight: 500
                    }
                }}
            />

            &nbsp;

            { ` ` }

            <Highlight text={ option?.structuredFormatting?.secondaryText || '' }
                highlights={ option?.structuredFormatting?.secondaryTextMatchedSubstrings || [] }
                sx={{
                    em: {
                        color: 'inherit',
                        backgroundColor: 'inherit',
                        fontWeight: 500
                    },
                    color: theme => theme.palette.text.secondary
                }}
            />

            { option && !option.structuredFormatting && option.text }
        </li>
    );
}
